import "./App.css";
import { Routes, Route } from "react-router-dom";
import PrivateRoute from "./utils/PrivateRoute";

// pages imported
import RegisterPage from "./pages/Auth/RegisterPage";
import LoginPage from "./pages/Auth/LoginPage";
import ForgotPage from "./pages/Auth/ForgotPage";

import ExamHome from "./pages/Assessment/ExamHome";
import useAuth from "./hooks/useAuth";
import StartExamPage from "./pages/Assessment/StartExamPage";
import FlashHome from "./pages/FlashCard/FlashHome";
import PlayHome from "./pages/FlashCard/PlayHome";
import ModExamPage from "./pages/Assessment/ModExamPage";
import ModDeckPage from "./pages/FlashCard/ModDeckPage";

// MainLayout.js
import { Outlet } from "react-router-dom";
import NavBar from "./components/NavBar/NavBar";
import LandingPage from "./pages/Landing/LandingPage";
import DashPage from "./pages/Dash/DashPage";
import ExamReport from "./pages/Assessment/ExamReport";
import { useEffect, useState } from "react";
import GlobalErrorPage from "./pages/Auth/ErrorPage";

const MainLayout = () => (
  <div className="page">
    <NavBar />
    <Outlet />
  </div>
);

// App.js
function App() {
  const [user, token] = useAuth();
  const [errorStatus, setErrorStatus] = useState(null);

  useEffect(() => {
    const handleApiError = (event) => {
      setErrorStatus(event.detail);
    };

    window.addEventListener("api-error", handleApiError);
    return () => window.removeEventListener("api-error", handleApiError);
  }, []);

  if (errorStatus) {
    return <GlobalErrorPage statusCode={errorStatus} />;
  }

  return (
    <Routes>
      {/* Routes WITH Navbar */}
      <Route element={<MainLayout />}>
        {/* EXAM ROUTES */}
        <Route
          path="/exams"
          element={
            <PrivateRoute>
              <ExamHome user={user} token={token} />
            </PrivateRoute>
          }
        />
        <Route
          path="/exams/:examId"
          element={
            <PrivateRoute>
              <ModExamPage user={user} token={token} />
            </PrivateRoute>
          }
        />
        {/* FLASHCARD ROUTES */}
        <Route
          path="/flashcards"
          element={
            <PrivateRoute>
              <FlashHome user={user} token={token} />
            </PrivateRoute>
          }
        />
        <Route
          path="/flashcards/deck/:deckId"
          element={
            <PrivateRoute>
              <ModDeckPage user={user} token={token} />
            </PrivateRoute>
          }
        />
        {/* DASH ROUTE */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashPage user={user} token={token} />
            </PrivateRoute>
          }
        />
      </Route>

      {/* Routes WITHOUT Navbar */}
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/flashcards/play"
        element={
          <PrivateRoute>
            <PlayHome user={user} token={token} />
          </PrivateRoute>
        }
      />
      <Route
        path="/:examName"
        element={<StartExamPage user={user} token={token} />}
      />
      <Route
        path="/report/:examId"
        element={<ExamReport user={user} token={token} />}
      />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPage />} />
    </Routes>
  );
}

export default App;
